import { render, staticRenderFns } from "./SearchResultTheme0.vue?vue&type=template&id=047b3712&scoped=true"
import script from "./SearchResultTheme0.vue?vue&type=script&lang=js"
export * from "./SearchResultTheme0.vue?vue&type=script&lang=js"
import style0 from "./SearchResultTheme0.vue?vue&type=style&index=0&id=047b3712&prod&scoped=true&lang=css"
import style1 from "./SearchResultTheme0.vue?vue&type=style&index=1&id=047b3712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b3712",
  null
  
)

export default component.exports